import { extent } from "d3-array";
import { nest } from "d3-collection";
import { interpolatePath } from "d3-interpolate-path";
import { select } from "d3-selection";
import * as paths from "d3-shape";
import { constant, merge } from "d3plus-common";
import Shape from "./Shape";
/**
    @class Line
    @extends Shape
    @desc Creates SVG lines based on an array of data.
*/

var Line = function (Shape) {
  function Line() {
    var this$1 = this;
    Shape.call(this);
    this._curve = "linear";

    this._defined = function (d) {
      return d;
    };

    this._fill = constant("none");
    this._hitArea = constant({
      "d": function d(_d) {
        return this$1._path(_d.values);
      },
      "fill": "none",
      "stroke-width": 10,
      "transform": null
    });
    this._name = "Line";
    this._path = paths.line();
    this._stroke = constant("black");
    this._strokeWidth = constant(1);
  }

  if (Shape) Line.__proto__ = Shape;
  Line.prototype = Object.create(Shape && Shape.prototype);
  Line.prototype.constructor = Line;
  /**
      @memberof Line
      @desc Filters/manipulates the data array before binding each point to an SVG group.
      @param {Array} [*data* = the data array to be filtered]
      @private
  */

  Line.prototype._dataFilter = function _dataFilter(data) {
    var this$1 = this;
    var lines = nest().key(this._id).entries(data).map(function (d) {
      d.data = merge(d.values);
      d.i = data.indexOf(d.values[0]);
      var x = extent(d.values, this$1._x);
      d.xR = x;
      d.width = x[1] - x[0];
      d.x = x[0] + d.width / 2;
      var y = extent(d.values, this$1._y);
      d.yR = y;
      d.height = y[1] - y[0];
      d.y = y[0] + d.height / 2;
      d.nested = true;
      d.translate = [d.x, d.y];
      d.__d3plusShape__ = true;
      return d;
    });

    lines.key = function (d) {
      return d.key;
    };

    return lines;
  };
  /**
      @memberof Line
      @desc Draws the lines.
      @param {Function} [*callback*]
      @chainable
  */


  Line.prototype.render = function render(callback) {
    var this$1 = this;
    Shape.prototype.render.call(this, callback);
    var that = this;

    this._path.curve(paths["curve" + this._curve.charAt(0).toUpperCase() + this._curve.slice(1)]).defined(this._defined).x(this._x).y(this._y);

    this._enter.append("path").attr("transform", function (d) {
      return "translate(" + (-d.xR[0] - d.width / 2) + ", " + (-d.yR[0] - d.height / 2) + ")";
    }).attr("d", function (d) {
      return this$1._path(d.values);
    }).call(this._applyStyle.bind(this));

    this._update.select("path").transition(this._transition).attr("transform", function (d) {
      return "translate(" + (-d.xR[0] - d.width / 2) + ", " + (-d.yR[0] - d.height / 2) + ")";
    }).attrTween("d", function (d) {
      return interpolatePath(select(this).attr("d"), that._path(d.values));
    }).call(this._applyStyle.bind(this));

    return this;
  };
  /**
      @memberof Line
      @desc Given a specific data point and index, returns the aesthetic properties of the shape.
      @param {Object} *data point*
      @param {Number} *index*
      @private
  */


  Line.prototype._aes = function _aes(d, i) {
    var this$1 = this;
    return {
      points: d.values.map(function (p) {
        return [this$1._x(p, i), this$1._y(p, i)];
      })
    };
  };
  /**
      @memberof Line
      @desc If *value* is specified, sets the line curve to the specified string and returns the current class instance. If *value* is not specified, returns the current line curve.
      @param {String} [*value* = "linear"]
      @chainable
  */


  Line.prototype.curve = function curve(_) {
    return arguments.length ? (this._curve = _, this) : this._curve;
  };
  /**
      @memberof Line
      @desc If *value* is specified, sets the defined accessor to the specified function and returns the current class instance. If *value* is not specified, returns the current defined accessor.
      @param {Function} [*value*]
      @chainable
  */


  Line.prototype.defined = function defined(_) {
    return arguments.length ? (this._defined = _, this) : this._defined;
  };

  return Line;
}(Shape);

export default Line;